import { useState, useCallback, useEffect } from "react";
import { userWorkspaceSettingsService } from "../services/userWorkspaceSettingsService";

export const useUserWorkspaceSettings = ({ token, workspaceId }) => {
    const [settings, setSettings] = useState({
        enableEventCompletion: false,
        lastOpenedChecklistId: null,
    });
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchSettings = useCallback(async () => {
        if (!workspaceId) {
            setLoading(false);
            return;
        }
        setLoading(true);
        try {
            const data = await userWorkspaceSettingsService.getSettings(token, workspaceId);
            setSettings({

                // Let's check other services. apiClient usually returns raw data.
                // My backend route returns `...settings`. Service returns `settings` object keys (snake_case from DB).
                // Wait, repository returns DB rows (snake_case). Service returns camelCase map?
                // Backend Service `getSettings`:
                // return { enableEventCompletion: settings.enable_event_completion, ... }
                // So backend service ALREADY converts to camelCase.
                // So here I receive camelCase.
                enableEventCompletion: data.enableEventCompletion,
                lastOpenedChecklistId: data.lastOpenedChecklistId,
            });
            setError(null);
        } catch (err) {
            console.error(err);
            setError("Failed to load settings");
        } finally {
            setLoading(false);
        }
    }, [token, workspaceId]);

    const updateSetting = async (key, value) => {
        // Optimistic update
        setSettings((prev) => ({ ...prev, [key]: value }));
        try {
            await userWorkspaceSettingsService.updateSettings(token, workspaceId, {
                [key]: value,
            });
        } catch (err) {
            console.error(err);
            // Revert? For now just log.
            fetchSettings();
        }
    };

    useEffect(() => {
        fetchSettings();
    }, [fetchSettings]);

    return {
        settings,
        loading,
        error,
        updateSetting,
        reload: fetchSettings,
    };
};
